import DetailTheme from "../components/detailTheme/DetailTheme";

const DetailThemePage = () => {
  return <DetailTheme />;
};

export default DetailThemePage;
